import { createContext, useContext, type Dispatch, type ReactNode, type SetStateAction } from "react";
import type { SessionBootstrapResult, SessionPayload } from "./api";
export type SessionContextValue = {
  session: SessionPayload | null;
  setSession: Dispatch<SetStateAction<SessionPayload | null>>;
  loading: boolean;
  refresh: () => Promise<SessionBootstrapResult>;
};
const SessionContext = createContext<SessionContextValue | null>(null);
export function SessionProvider({ value, children }: { value: SessionContextValue; children: ReactNode }) {
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}
export function useSessionContext(): SessionContextValue {
  const value = useContext(SessionContext);
  if (!value) {
    throw new Error("useSessionContext must be used inside SessionProvider");
  }
  return value;
}
